import {ServiceProgressPriority, ServiceStatus, SortOrder} from 'src/app/core/enum/table.enum';
import {ECommentType} from 'src/app/core/interfaces/comment.interface';
import {UsersService} from '../services/users.service';
import {AuthService} from 'src/app/core/services/auth.service';

export class GetQuery {
  index: number;
  limit: number;
  sortKey: string;
  sortOrder: SortOrder;
  constructor (limit: number = 20) {
    this.index = 0;
    this.limit = limit;
    this.sortKey = 'createdAt';
    this.sortOrder = SortOrder.desc;
  }

  set _index(value: number) {
    this.index = value;
  }

  set _limit(value: number) {
    this.limit = value;
  }

  set _sortKey(value: string) {
    this.sortKey = value;
  }

  set _sortOrder(value: SortOrder) {
    this.sortOrder = value;
  }
  reset() {
    this.index = 0;
  }
}

export class GetCommentsFilter extends GetQuery {
  type!: ECommentType;
  stats!: boolean;
  constructor (type?: ECommentType) {
    super();
    if (type) {
      this.type = type;
    }
  }
}
export class GetLeadsQuery extends GetQuery {
  userId?: string;
  serviceId?: string;
  status?: ServiceStatus[];
  priority?: ServiceProgressPriority[];
  onlyUnAssigned?: boolean;
  consultantIds?: string[];
  serviceIds?: string[];


  set _userId(value: string) {
    this.userId = value;
  }

  set _serviceId(value: string) {
    this.serviceId = value;
  }

  set _status(value: ServiceStatus[]) {
    this.status = typeof value === 'string' ? [value] : value;
  }

  set _priority(value: ServiceProgressPriority[]) {
    this.priority = typeof value === 'string' ? [value] : value;
  }

  set _onlyUnAssigned(value: boolean) {
    this.onlyUnAssigned = value;
  }

  set _consultantIds(ids: string[]) {
    this.consultantIds = typeof ids === 'string' ? [ids] : ids;;
  }

  set _serviceIds(ids: string[]) {
    this.serviceIds = typeof ids === 'string' ? [ids] : ids;
  }
}

export class GetGuidanceOrdersQuery extends GetQuery {
  serviceIds?: string[];
  status?: ServiceStatus[];
  consultantIds?: string[];

  set _status(value: ServiceStatus[]) {
    this.status = typeof value === 'string' ? [value] : value;
  }

  set _consultantIds(ids: string[]) {
    this.consultantIds = typeof ids === 'string' ? [ids] : ids;;
  }

  set _serviceIds(ids: string[]) {
    this.serviceIds = typeof ids === 'string' ? [ids] : ids;
  }
}